import React from 'react';
import {connect} from 'react-redux';
import {Form, Errors, Control, actions} from 'react-redux-form'
import {Grid, Row, Col, Radio} from 'react-bootstrap'
import classnames from "classnames";
import BackLink from '../common/back-link/index'
import ArrowButton from '../common/button-arrow'
import PageTitle from '../common/page-title/index'
import RequiredInput from '../common/form/elements/required-input';
import RequiredSelect from '../common/form/elements/required-select';
import {getPage, savePage, getTemplates, getPages, storePage} from '../../actions/pages';

class Page extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const {dispatch} = this.props;
    if (this.props.match.params.id === undefined) {
      dispatch(actions.reset("deep.page"));
    } else {
      dispatch(getPage(this.props.match.params.id));
    }
    dispatch(getTemplates());
    dispatch(getPages());

    dispatch({type: 'SET_PAGE_NAME_NOT_TAKEN'})
  }

  onSaveClicked = (payload) => {
    if (this.props.match.params.id === undefined) {
      this.props.dispatch(actions.submit('deep.page', storePage(payload, this.props.match.params.id)))
    } else {
      this.props.dispatch(actions.submit('deep.page', savePage(payload, this.props.match.params.id)))
    }
  };

  handleNameChange = (event) => {
    const {dispatch, pages} = this.props;
    const value = event.target.value;

    if (pages.find(p => p.name === value)) {
      dispatch({
        type: "SET_PAGE_NAME_TAKEN",
      });
    } else {
      dispatch({
        type: "SET_PAGE_NAME_NOT_TAKEN",
      });
    }
  };

  render() {

    if (this.props.fetched === true) {
      return (
        <div>
          <Form model="deep.page"
                onSubmit={this.onSaveClicked}
                validators={{
                  '': {
                        login_required: (vals) => vals.login_required
                      }
                }}>
            <Grid bsClass="container" fluid className="users">
              <Row>
                <Col lg={12}>
                  <BackLink href="/admin/pages"/>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <PageTitle>Add/Edit page</PageTitle>
                </Col>
              </Row>
              <Col lg={12}>
                <RequiredInput model=".name"
                               placeholder="Name"
                               label="Name"
                               onBlur={this.handleNameChange}/>

                  <div className={classnames({errors: true, hidden: !this.props.taken})}>
                    <span>Name has been already taken.</span>
                  </div>
              </Col>
              <Col lg={12}>
                <RequiredSelect model=".page_template"
                                label="Page template"
                                values={this.props.templates.templates || []}/>
              </Col>
              <Col lg={12}>
                <div >Login required*</div>
              </Col>
              <Col lg={12}>
                <Row>
                  <Col lg={12}>
                    <Control.radio model=".login_required"
                                   value="true"
                                   component={Radio}>Yes</Control.radio>
                  </Col>
                  <Col lg={12}>
                    <Control.radio model=".login_required"
                                   value="false"
                                   component={Radio}>No</Control.radio>
                  </Col>
                  <Col lg={12}>
                    <Errors show={{touched: true}}
                            className="errors"
                            model=".login_required"
                            messages={{login_required: 'You must set if login is required.'}}/>
                  </Col>
                </Row>
              </Col>
              <Row>
                <Col lg={12}>
                  <ArrowButton color="red"
                               className="pull-right"
                               arrow={false}
                               disabled={this.props.taken || !this.props.formValid}>Save</ArrowButton>
                </Col>
              </Row>
            </Grid>
          </Form>
        </div>
      );
    }
    return (
      <div>
        Loading...
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pages: state.pages.pages.Content,
    templates: state.templates.templates,
    fetched: state.pages.fetched,
    fetching: state.pages.fetching,
    taken: state.pages.pageNameTaken,
    formValid: state.deep.forms.page.$form.valid
  };
};

export default connect(mapStateToProps)(Page);


// WEBPACK FOOTER //
// ./src/components/pages/add-edit.jsx